import axios, { AxiosInstance } from 'axios';
import { CommunicationBridge } from '@sequelae/lore-mfe-kit';

export interface VerificationData {
  community_ref_user_id: number;
  is_verified: boolean;
  is_enabled: boolean;
  input_first_name: string;
  input_last_name: string;
  input_birth_date: string;
  input_email: string;
}

// Verification API Configuration
// Using custom domains (matching Android implementation)
// Custom domains now have SSL certificates configured
const VERIFICATION_API_BASE_URL =
  process.env.REACT_APP_VERIFICATION_API_BASE_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://verification-api.lorehealthcare.com'
    : 'https://lore-verification-service-eex6i6xwzq-uc.a.run.app');

console.log('[MenuMFE] Verification Service API Base URL:', VERIFICATION_API_BASE_URL);

// Create axios instance with default config
const api: AxiosInstance = axios.create({
  baseURL: VERIFICATION_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add response interceptor for error handling
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      console.error('[MenuMFE] Verification API - Authentication failed');
    } else if (error.response?.status === 403) {
      console.error('[MenuMFE] Verification API - Authorization failed: Access denied');
    } else if (error.response?.status === 404) {
      // 404 is acceptable - user may not have verification data yet
      console.log('[MenuMFE] Verification API - No verification data found (404)');
    }
    return Promise.reject(error);
  }
);

// Verification API methods
export const verificationApi = {
  getVerificationStatus: async (): Promise<VerificationData | null> => {
    try {
      console.log('[MenuMFE] Fetching verification status');
      const response = await api.get('/api/verification/status', {
        headers: {
          Authorization: `Bearer ${CommunicationBridge.getAccessToken()}`,
        },
      });

      console.log('[MenuMFE] Verification status response:', response.data);
      return response.data;
    } catch (error: any) {
      // Return null if no verification data exists (404) or other errors
      if (error.response?.status === 404) {
        console.log('[MenuMFE] No verification data found for user');
        return null;
      }
      console.error('[MenuMFE] Error fetching verification status:', error);
      return null;
    }
  },
};

// Export singleton for backward compatibility
const verificationService = {
  getVerificationStatus: verificationApi.getVerificationStatus,
};

export default verificationService;
